import React from 'react';
import { motion } from 'framer-motion';
export function PurchaseSection() {
  const plans = [{
    title: '1 Bolsa Pouch',
    subtitle: '(Prueba) - 31 dias',
    description: 'Ideal para conocer la textura y pureza.',
    highlight: false,
    price: '$546',
    originalPrice: null,
    discountLabel: null,
    tag: null,
    badge: null,
    url: 'https://althypro.com/products/myochiro-pro-40-1-caronositol%C2%AE',
    ctaText: 'Comprar 1 Bolsa'
  }, {
    title: '3 Bolsas Pouch',
    subtitle: '(Protocolo Completo) - 93 dias',
    description: 'Recomendado para ver cambios estructurales en el ciclo.',
    badge: 'EL MÁS VENDIDO',
    tag: 'Mejor Valor',
    highlight: true,
    price: '$1,474.20',
    originalPrice: '$1,638',
    discountLabel: '10% OFF',
    url: 'https://althypro.com/products/myochiro-pro-40-1-3-bolsas-pouch-90-dias',
    ctaText: 'Comprar 3 Bolsas'
  }];
  return <section className="py-20 md:py-32 bg-cream text-dark" id="comprar" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-149">
          <h2 className="text-3xl md:text-5xl font-heading mb-6" data-id="element-150">
            Elige tu Protocolo{' '}
            <span className="text-pink-brand" data-id="element-151">MyoChiro-Pro.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch max-w-5xl mx-auto" data-id="element-152">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className={`relative bg-white rounded-3xl p-8 flex flex-col h-full ${plan.highlight ? 'border-2 border-pink-brand shadow-2xl md:scale-105 z-10' : 'border border-warm-gray shadow-lg'}`} data-id="element-153">
              {plan.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-pink-brand text-white px-4 py-1 rounded-full text-sm font-bold tracking-wider whitespace-nowrap" data-id="element-154">
                  {plan.badge}
                </div>}

              <div className="text-center mb-6 mt-4" data-id="element-155">
                <h3 className="text-2xl font-bold text-dark" data-id="element-156">{plan.title}</h3>
                <p className="text-pink-brand font-medium" data-id="element-157">{plan.subtitle}</p>
              </div>

              <div className="flex justify-center mb-6" data-id="element-158">
                <img src="https://cdn.magicpatterns.com/uploads/smVAooat9iky3z4Loca9sd/inositol_frente.png" alt={`MyoChiro-Pro ${plan.title}`} className={`w-auto object-contain drop-shadow-lg ${plan.highlight ? 'h-48' : 'h-40'}`} data-id="element-159" />
              </div>

              <div className="text-center mb-8 flex-grow" data-id="element-160">
                <p className="text-gray-600" data-id="element-161">{plan.description}</p>

                {plan.tag && <span className="inline-block mt-4 bg-green-brand/10 text-green-brand font-bold px-3 py-1 rounded-full text-sm" data-id="element-162">
                    {plan.tag}
                  </span>}
              </div>

              <div className="mt-auto" data-id="element-163">
                <div className="text-center mb-5" data-id="element-164">
                  {plan.originalPrice && <div className="flex items-center justify-center gap-2 mb-1 flex-wrap" data-id="element-165">
                      <span className="text-gray-400 line-through text-base" data-id="element-166">
                        {plan.originalPrice}
                      </span>

                      {plan.discountLabel && <span className="bg-pink-brand/10 text-pink-brand text-xs font-bold px-2 py-1 rounded-full" data-id="element-167">
                          {plan.discountLabel}
                        </span>}
                    </div>}

                  <p className="text-3xl font-bold text-dark" data-id="element-168">{plan.price}</p>
                </div>

                <a href={plan.url} className={`block w-full text-center py-4 rounded-full font-bold transition-all duration-300 ${plan.highlight ? 'bg-pink-brand text-white hover:bg-pink-brand/90 hover:shadow-lg hover:-translate-y-1' : 'bg-dark text-white hover:bg-dark-surface hover:shadow-md'}`} data-id="element-169">
                  {plan.ctaText}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}